import React from 'react'
import { heroImage } from '../../data/constant'
import { Link } from 'react-router-dom'

function Home() {
    return (
      
            <div className="container-xxl bg-primary hero-header">
                <div className="container px-lg-5">
                    <div className="row g-5 align-items-end">
                        <div className="col-lg-6 text-center text-lg-start">
                            <h1 className="text-white mb-4 animated slideInDown">A Digital Agency Of Inteligents &amp; Creative People</h1>
                            <p className="text-white pb-3 animated slideInDown">

                                Committed to lasting impact and positive change, our expert team turns shared beliefs into daily action, achieving extraordinary outcomes through innovation and collective wisdom.
                            </p>

                            <Link to="/about" className="btn btn-secondary py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft">Read More</Link>
                            <Link to="/contact" className="btn btn-light py-sm-3 px-sm-5 rounded-pill animated slideInRight">Contact Us</Link>
                        </div>
                        <div className="col-lg-6 text-center text-lg-start">
                            <img className="img-fluid animated zoomIn" src={heroImage} alt='' />
                        </div>
                    </div>
                </div>
            </div>
      
    )
}

export default Home